<template>
  <v-navigation-drawer
      app
      clipped
      right
      v-model="RIGHT_BUILDING_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !RIGHT_BUILDING_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16"
      width="400"
  >
    <div v-show="!isMini">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_BUILDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar')}}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_BUILDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">link</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar')}}</span>
      </v-tooltip>
    </div>

    <v-divider></v-divider>

    <v-expansion-panels v-show="!isMini" tile accordion>
      <!-- Role expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>engineering</v-icon></v-col>
            <v-col cols="5">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:role_plural')}} ({{ restRoles.length }})</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" rounded small elevation="0" @click.native.stop="quickLinkAction1">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item v-for="item in restRoles" :key="item.id">
              <v-avatar size="40">
                <v-img
                    src="@/assets/default_profile_pic.png"
                ></v-img>
              </v-avatar>
              <v-row class="ml-2" align="center">
                <v-col>
                  <span>{{ item.userName }} - {{ item.roleName }}</span>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn color="primary" icon @click="callPhoneNumber(item.userPhone)">
                    <v-icon>phone</v-icon>
                  </v-btn>
                  <v-btn color="primary" icon @click="writeEMail(item.userEmail)">
                    <v-icon>email</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Facility expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>account_tree</v-icon></v-col>
            <v-col cols="5">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:facility_plural')}} ({{ restFacilities.length }})</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" rounded small elevation="0" @click.native.stop="quickLinkAction2">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restFacilities" :key="item.id" :to="`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}`">
                <span class="ml-2">{{ item.name }}</span>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- TODO uncomment when needed -->
      <!-- bills expansion panel -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>developer_board</v-icon></v-col>
            <v-col cols="5">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('book/building:building.quicklink-sidebar.invoices-title')}} ({{ restInvoices.length }})</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" rounded small @click.native.stop="quickLinkAction3">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item v-for="item in restInvoices" :key="item.id">
              <span class="ml-2">{{ item.name }}</span>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
    </v-expansion-panels>
  </v-navigation-drawer>
</template>
<script>
import BuildingService from "@/modules/book/services/building-service";
import FacilityUserAssignmentService from "@/modules/book/services/facility-user-assignment-service";

import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

import Facility from "@/modules/book/data/facility";
import FacilityUserAssignment from "@/modules/book/data/facility-user-assignment";

import {mapActions, mapState} from 'vuex'

export default {
  name: 'BuildingQuickLinkSidebar',
  data() {
    return {
      restFacilities: [],
      restRoles: [],
      restInvoices: []
    }
  },
  computed: {
    ...mapState('book/layout', {
      rightBuildingDrawer: state => state.rightBuildingDrawer
    }),
    RIGHT_BUILDING_DRAWER_STATE: {
      get() {
        return this.rightBuildingDrawer
      },
      set(newValue) {
        if (newValue === this.rightBuildingDrawer) return;
        this.TOOGLE_RIGHT_BUILDING_DRAWER_STATE();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.RIGHT_BUILDING_DRAWER_STATE
      } else {
        return !this.RIGHT_BUILDING_DRAWER_STATE
      }
    }
  },
  methods: {
    ...mapActions(
        'book/layout', ['TOOGLE_RIGHT_BUILDING_DRAWER_STATE']
    ),
    quickLinkAction1() {
      this.$emit('quickLinkAction1')
    },
    quickLinkAction2() {
      this.$emit('quickLinkAction2')
    },
    quickLinkAction3() {
      this.$emit('quickLinkAction3')
    },

    // open new window to call user by phone number
    callPhoneNumber(phoneNumber) {
      window.open('tel:' + phoneNumber)
    },

    writeEMail(email) {
      window.open('mailto:' + email)
    },
  },
  created() {
    FacilityUserAssignmentService.readFacilityUserAssignmentsForBuilding(this.$route.params.id,
      (res) => {
        this.restRoles = DataUtils.parseDataToObjectArray(res.data, FacilityUserAssignment);

        this.restRoles.sort((a, b) => {
            if(a.userName < b.userName) {
              return -1;
            }

            if(a.userName > b.userName) {
              return 1;
            }

            return 0;
          })

      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:role_plural')}))
        this.$logger.error(error);
      }
    )

    BuildingService.readFacilitiesForBuilding(this.$route.params.id,
      (res) => {
        this.restFacilities = DataUtils.parseDataToObjectArray(res.data, Facility);

        this.restFacilities.sort((a, b) => {
            if(a.name < b.name) {
              return -1;
            }

            if(a.name > b.name) {
              return 1;
            }

            return 0;
          })
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility_plural')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>
